<template>
  <main class="dashboard links">
    <div class="mb-4 row">
      <h2 class="col">Запросы</h2>
      <div>
         <router-link active-class="active" class="btn btn-sm btn-outline-dark" to="/external_doc/" exact>
        <i class="bi bi-filetype-doc"></i> doc
      </router-link>
        </div>

    </div>

    <!--     <form v-if="empty_person.edit" action="" @submit.prevent="savePerson(empty_person)" class="d-flex create-form mt-2">-->
    <!--      <label for="">Название</label>-->
    <!--      <input v-model="empty_person.name" required type="text" class="form-control">-->
    <!--      <label for="">ID ПланФикс</label>-->
    <!--      <input v-model="empty_person.pf_id" type="text" class="form-control">-->
    <!--      <button type="submit" class="btn btn-sm btn-outline-dark">Сохранить</button>-->
    <!--      <button type="button" @click.prevent="empty_person.edit=false" class="btn btn-sm btn-outline-secondary">Отмена</button>-->
    <!--    </form>-->

    <div class="card">
      <div class="card-body">
        <div class="table-responsive d-flex" style="height: auto; overflow: visible">
          <table class="table">
            <thead>
            <tr>
              <th scope="col"> №</th>
              <th scope="col">Клиент</th>
              <th scope="col">Данные</th>
              <th scope="col">PDF</th>
              <th scope="col">Статус</th>
              <th scope="col">Дата</th>
            </tr>
            </thead>
            <!--            <tbody>-->
            <template v-for="(request, index) in requests">
              <tr>
                <td>{{ index + 1 }}</td>
                <td>{{ request.client.name }}</td>
                <td>
                  <span v-if="request.full_name"> <strong>Имя</strong>: {{ request.full_name }}<br></span>
                  <span v-if="request.comment" style="line-break: anywhere; max-width: 350px; display: block;"><strong>Комментарий</strong>: {{ request.comment }}</span>
                </td>
                <td>
                  <div v-if="request.status === 'wait'" class="spinner-border text-primary" role="status"></div>
                  <template v-else>
                    <a v-if="request.pdf_file" target="_blank" :href="request.pdf_file" class="badge bg-secondary">Отправлен</a>
                    <div v-else>
                      <input type="file" accept="application/pdf" :ref="'pdf-'+request.id">
                      <button class="btn btn-sm btn-dark" @click="sendFile('pdf-'+request.id, request)">Отправить
                      </button>
                    </div>
                  </template>
                </td>
                <td>
                  <div v-if="request.status === 'wait'" class="spinner-border text-primary" role="status"></div>
                  <span v-else :class="`badge `+request.status">{{ request.status_display }}</span>

                </td>
                <td>{{ $moment(request.date_create).format("DD.MM.YYYY HH:mm") }}</td>
              </tr>

            </template>
            <!--            </tbody>-->
          </table>
        </div>
      </div>
      <nav>
        <ul class="pagination justify-content-center fz-9" v-if="pager.length">
          <li :class="`page-item${p===page?' active':''}`" v-for="p in pager">
            <a v-if="typeof p === 'number'" class="page-link" v-on:click.prevent="page=p" href="">{{ p }}</a>
            <span class="page-link" v-else>{{ p }}</span>
          </li>
        </ul>
      </nav>

    </div>


  </main>
</template>

<script>
import {ExternalApi} from "@/api/external_requests";

export default {
  name: "ExternalRequests",

  data() {
    return {
      requests: [],
      page: 1,
      size: 50,
      all_count: 0,
    }
  },
  watch: {
    page() {
      this.getList()
    }
  },
  computed: {
    pager() {
      let page_count = Math.ceil(this.all_count / this.size);
      let pages = Array.from({length: page_count}, (_, i) => i + 1);
      let array = [];
      if (this.page > 5) {
        array = array.concat(pages.slice(0, this.page - 3 > 3 ? 3 : this.page - 3));
        array.push('...')
      }
      array = array.concat(pages.slice(this.page - 4 > 0 ? this.page - 4 : 0, this.page + 3));
      if (this.page < (pages.length - 5)) {
        array.push('...');
        array = array.concat(pages.slice(pages.length - 3, pages.length));
      }
      return array;
    },
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    sendFile(ref_name, request) {
      const $this = this;
      const file = this.$refs[ref_name][0].files[0]
      if (!file) {
        this.$notify({
          type: "error",
          title: "Ошибка",
          text: 'Файл не выбран'
        });
      } else {
        let formData = new FormData();
        formData.append("pdf", file);
        request.status = "wait"
        let request_index = $this.requests.findIndex(x => x.id === request.id);
        ExternalApi.post(request.id, formData).then(response => {
          $this.requests.splice(request_index, 1, response)
          this.$notify({
          type: "success",
          title: "Успешно",
          text: 'Файл отправлен'
        });
        })
      }
    },
    getList() {
      const $this = this;
      let query = {}
      query.page = this.page;
      query.size = this.size;
      query = this.$func.createSearchParams(query).toString()
      ExternalApi.list(query).then(response => {
        $this.requests = response.results;
        $this.all_count = response.count;
      })
    },
    savePerson(person) {

    }
  },
}
</script>
<style scoped lang="scss">
.create-form {
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: end;
  margin-bottom: 20px;

  input {
    width: 250px;
  }
}

.badge {
  &.pending {
    background: #0d6efd
  }

  &.processing {
    background: rgb(252, 189, 6)
  }

  &.completed {
    background: rgb(13, 206, 112)
  }

  &.failed {
    background: rgb(254, 66, 45)
  }
}

</style>